import { runInAction, makeAutoObservable } from 'mobx';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { UserInfo } from 'types/userService';
import { editUserInformation, getUserByToken } from 'api/operations/userService';
import { RootStore } from '../../rootStore';

interface AccountSettingsFields extends DefaultFormFields {
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  telephone: FormControl<string>;
  npn: FormControl<string>;
}

export default class AccountSettingsStore {
  rootStore: RootStore;
  accountSettingsForm: FormController<AccountSettingsFields>;
  formFields = { firstName: '', lastName: '', telephone: '', npn: '' };

  loading = false;

  private setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  public async getUserInfo(): Promise<void> {
    this.setLoading(true);
    const res = await getUserByToken();
    runInAction(() => {
      if (res) {
        const data = res.data.userByToken;
        // Block the ability to clear the NPN field if it's not empty for a user who has already set it
        if (data.npn) {
          this.accountSettingsForm.fields.npn.setOptionalFlag(false);
        }

        this.accountSettingsForm.populateFields({
          ...data,
          npn: data.npn || '',
        });
      }
      this.setLoading(false);
    });
  }

  public updateUserInfo = async (): Promise<void> => {
    this.setLoading(true);

    const userFromForm: UserInfo = {
      firstName: this.accountSettingsForm.fields.firstName.value,
      lastName: this.accountSettingsForm.fields.lastName.value,
      telephone: this.accountSettingsForm.fields.telephone.value,
      npn: this.accountSettingsForm.fields.npn.value,
    };
    const res = await editUserInformation(userFromForm);

    runInAction(() => {
      if (res) {
        window.location.href = `https://${process.env.REACT_APP_BROKER_PORTAL_BASE_URL}/dashboard`;
      }
    });
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.accountSettingsForm = new FormController({
      firstName: new FormControl<string>('', { validations: ['validName'], trim: true }),
      lastName: new FormControl<string>('', { validations: ['validName'], trim: true }),
      telephone: new FormControl<string>('', { validations: ['isValidUSAPhoneNumber'], trim: true }),
      npn: new FormControl<string>('', { optional: true, validations: ['validNpn'], trim: true }),
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
